<div class="strip" role="list">
    @for (item of items; track item) {
        <button
                class="block"
                role="listitem"
                type="button"
                [title]="item.id"
                [attr.aria-pressed]="isSelected(item.id)"
                [disabled]="disabled"
                (click)="toggle(item.id)"
                (keydown)="onKeydown($event, item.id)"
                [style.background]="item.color"
                [ngClass]="{ 'selected': isSelected(item.id) }"
                [matTooltip]="value_descriptions[item.id]"
        >
            <span class="title">{{value_descriptions[item.id]}}</span>
            @if (!isSelected(item.id)) {
                <span class="overlay"></span>
            }
        </button>
    }
</div>